const sounds = {
  correct: new Audio('/sounds/correct.mp3'),    // Short success chime
  wrong: new Audio('/sounds/wrong.mp3'),        // Quick error buzz
  hint: new Audio('/sounds/hint.mp3'),          // Light bell sound
  achievement: new Audio('/sounds/achieve.mp3'), // Triumphant fanfare
  gameOver: new Audio('/sounds/complete.mp3')   // Game completion melody
};

// Add volume control
const setVolume = (volume) => {
  Object.values(sounds).forEach(sound => {
    sound.volume = volume;
  });
};

// Add mute control
let isMuted = false;

export const toggleMute = () => {
  isMuted = !isMuted;
  Object.values(sounds).forEach(sound => {
    sound.muted = isMuted;
  });
  return isMuted;
};

export const playSound = (soundName) => {
  const sound = sounds[soundName];
  if (sound && !isMuted) {
    sound.currentTime = 0;
    sound.play().catch(() => {
      // Handle autoplay restrictions
      console.log('Sound playback failed');
    });
  }
};

// Initialize volume to 50%
setVolume(0.5);

export { setVolume }; 